import { HTTP } from 'providers'
import { TraceabilityFilter } from 'types/Traceability.types'

export class RawMaterialService extends HTTP {
  private endpoint = '/rawMaterial'

  public async getRawMaterial(params: TraceabilityFilter) {
    const rawMaterial = await this.get({
      endpoint: this.endpoint,
      params
    })
    return rawMaterial
  }

  public async getRawMaterialExported(params: TraceabilityFilter) {
    const { data } = await this.get({
      endpoint: `${this.endpoint}/export`,
      params
    })

    return data
  }
}
